import { commonjsGlobal as o } from "../../../_virtual/_commonjsHelpers.js";
var t = function t(o) {
    return o && o.Math == Math && o;
  },
  e = t("object" == typeof globalThis && globalThis) || t("object" == typeof window && window) || t("object" == typeof self && self) || t("object" == typeof o && o) || function () {
    return this;
  }() || o || Function("return this")();
export { e as g };